function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "152px",
    height: "32px",
    viewBox: "0 0 152 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 40.011719 23.925781 C 39.117188 24.625 37.023438 26.019531 33.929688 26.019531 C 28.347656 26.019531 23.863281 21.832031 23.863281 16.050781 C 23.863281 10.269531 28.546875 6.082031 33.929688 6.082031 C 39.316406 6.082031 38.515625 7.078125 40.011719 8.074219 C 40.210938 8.175781 40.210938 8.472656 40.113281 8.671875 L 38.316406 11.363281 C 38.21875 11.5625 37.917969 11.664062 37.71875 11.464844 C 37.320312 11.164062 35.925781 10.070312 33.832031 10.070312 C 30.742188 10.070312 28.148438 12.761719 28.148438 16.050781 C 28.148438 19.339844 30.640625 22.03125 33.832031 22.03125 C 37.023438 22.03125 36.921875 21.132812 37.71875 20.636719 C 37.917969 20.535156 38.21875 20.636719 38.316406 20.734375 L 40.113281 23.328125 C 40.210938 23.527344 40.113281 23.726562 40.011719 23.925781 Z M 40.011719 23.925781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 51.375 26.019531 C 45.894531 26.019531 41.109375 21.929688 41.109375 16.050781 C 41.109375 10.167969 45.792969 6.082031 51.375 6.082031 C 56.960938 6.082031 61.546875 10.167969 61.546875 16.050781 C 61.546875 21.929688 56.859375 26.019531 51.375 26.019531 Z M 51.375 10.070312 C 48.085938 10.070312 45.496094 12.761719 45.496094 16.050781 C 45.496094 19.339844 48.085938 22.03125 51.375 22.03125 C 54.667969 22.03125 57.257812 19.339844 57.257812 16.050781 C 57.257812 12.761719 54.667969 10.070312 51.375 10.070312 Z M 51.375 10.070312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 83.078125 25.71875 L 79.789062 25.71875 C 79.589844 25.71875 79.390625 25.519531 79.390625 25.320312 L 79.390625 14.054688 L 75.5 20.734375 C 75.5 20.933594 75.300781 21.132812 75.101562 21.132812 L 72.3125 21.132812 C 72.113281 21.132812 72.011719 20.835938 71.914062 20.734375 L 68.023438 14.054688 L 68.023438 25.320312 C 68.023438 25.519531 67.824219 25.71875 67.625 25.71875 L 64.335938 25.71875 C 64.136719 25.71875 63.9375 25.519531 63.9375 25.320312 L 63.9375 6.777344 C 63.9375 6.578125 64.136719 6.378906 64.335938 6.378906 L 67.824219 6.378906 C 68.023438 6.378906 68.125 6.578125 68.222656 6.777344 L 73.609375 15.949219 L 78.992188 6.777344 C 79.089844 6.578125 79.191406 6.378906 79.390625 6.378906 L 82.878906 6.378906 C 83.078125 6.378906 83.277344 6.578125 83.277344 6.777344 L 83.277344 25.320312 C 83.277344 25.519531 83.078125 25.71875 82.878906 25.71875 Z M 83.078125 25.71875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 96.636719 19.9375 L 91.949219 19.9375 L 91.949219 25.320312 C 91.949219 25.621094 91.75 25.71875 91.550781 25.71875 L 88.160156 25.71875 C 87.960938 25.71875 87.761719 25.519531 87.761719 25.320312 L 87.761719 6.777344 C 87.761719 6.578125 87.960938 6.378906 88.160156 6.378906 L 96.734375 6.378906 C 100.421875 6.378906 103.414062 9.171875 103.414062 13.160156 C 103.414062 17.144531 100.421875 19.9375 96.734375 19.9375 Z M 95.738281 10.070312 L 91.949219 10.070312 L 91.949219 16.25 L 95.738281 16.25 C 97.433594 16.25 99.027344 15.351562 99.027344 13.160156 C 99.027344 10.964844 97.53125 10.070312 95.738281 10.070312 Z M 95.738281 10.070312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 119.863281 25.71875 L 116.175781 25.71875 C 115.875 25.71875 115.777344 25.519531 115.777344 25.222656 L 114.679688 21.730469 L 108 21.730469 L 106.902344 25.222656 C 106.902344 25.421875 106.703125 25.71875 106.40625 25.71875 L 102.714844 25.71875 C 102.417969 25.71875 102.21875 25.421875 102.417969 25.121094 L 109.195312 6.679688 C 109.195312 6.480469 109.394531 6.179688 109.59375 6.179688 L 113.085938 6.179688 C 113.382812 6.179688 113.484375 6.480469 113.484375 6.679688 L 120.160156 25.222656 C 120.160156 25.421875 120.160156 25.71875 119.863281 25.71875 Z M 111.289062 11.664062 L 109.195312 18.242188 L 113.484375 18.242188 L 111.390625 11.664062 Z M 111.289062 11.664062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 128.238281 26.019531 C 124.945312 26.019531 123.054688 24.921875 121.558594 23.824219 C 121.359375 23.726562 121.359375 23.425781 121.558594 23.226562 L 123.453125 20.734375 C 123.550781 20.535156 123.851562 20.535156 124.050781 20.734375 C 124.746094 21.234375 125.945312 22.230469 128.335938 22.230469 C 130.730469 22.230469 131.226562 20.636719 131.226562 20.136719 C 131.226562 18.441406 128.4375 18.144531 126.542969 17.445312 C 123.550781 16.347656 121.257812 15.152344 121.257812 11.464844 C 121.257812 7.777344 123.851562 6.179688 128.636719 6.179688 C 133.421875 6.179688 133.222656 7.175781 134.417969 7.875 C 134.617188 7.976562 134.714844 8.273438 134.515625 8.472656 L 132.824219 11.066406 C 132.722656 11.265625 132.421875 11.363281 132.222656 11.164062 C 131.824219 10.867188 130.332031 9.96875 128.535156 9.96875 C 125.445312 9.96875 125.644531 11.164062 125.644531 11.464844 C 125.644531 13.058594 128.734375 13.558594 131.425781 14.554688 C 134.117188 15.453125 135.714844 17.144531 135.714844 20.136719 C 135.714844 23.625 132.722656 26.019531 128.335938 26.019531 Z M 128.238281 26.019531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 143.789062 26.019531 C 140.5 26.019531 138.605469 24.921875 137.109375 23.824219 C 136.910156 23.726562 136.910156 23.425781 137.109375 23.226562 L 139.003906 20.734375 C 139.101562 20.535156 139.402344 20.535156 139.601562 20.734375 C 140.300781 21.234375 141.496094 22.230469 143.886719 22.230469 C 146.28125 22.230469 146.777344 20.636719 146.777344 20.136719 C 146.777344 18.441406 143.988281 18.144531 142.09375 17.445312 C 139.101562 16.347656 136.808594 15.152344 136.808594 11.464844 C 136.808594 7.777344 139.402344 6.179688 144.1875 6.179688 C 148.972656 6.179688 148.773438 7.175781 149.96875 7.875 C 150.167969 7.976562 150.269531 8.273438 150.070312 8.472656 L 148.375 11.066406 C 148.273438 11.265625 147.976562 11.363281 147.777344 11.164062 C 147.375 10.867188 145.882812 9.96875 144.085938 9.96875 C 140.996094 9.96875 141.195312 11.164062 141.195312 11.464844 C 141.195312 13.058594 144.285156 13.558594 146.976562 14.554688 C 149.667969 15.453125 151.265625 17.144531 151.265625 20.136719 C 151.265625 23.625 148.273438 26.019531 143.886719 26.019531 Z M 143.789062 26.019531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(89.019608%,2.352941%,7.450981%)",
      fillOpacity: 1
    },
    d: "M 0.238281 0.199219 L 16.285156 0.199219 L 16.285156 32 L 0.238281 32 Z M 0.238281 0.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.128906 23.925781 C 3.128906 26.816406 5.421875 29.007812 8.210938 29.109375 C 11.003906 29.109375 13.296875 26.816406 13.296875 23.925781 C 13.296875 21.035156 11.003906 18.839844 8.210938 18.742188 C 5.421875 18.742188 3.128906 21.035156 3.128906 23.925781 M 2.628906 23.925781 C 2.628906 20.734375 5.121094 18.144531 8.3125 18.144531 C 11.5 18.144531 13.992188 20.734375 13.992188 23.925781 C 13.992188 27.117188 11.5 29.707031 8.3125 29.707031 C 5.222656 29.707031 2.628906 27.117188 2.628906 23.925781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 4.921875 7.175781 C 4.921875 5.285156 6.417969 3.6875 8.3125 3.6875 C 10.207031 3.6875 10.007812 3.988281 10.605469 4.585938 L 10.207031 4.984375 C 9.707031 4.484375 9.007812 4.285156 8.3125 4.285156 C 6.714844 4.285156 5.421875 5.582031 5.421875 7.175781 C 5.421875 8.773438 6.714844 10.070312 8.3125 10.070312 C 9.90625 10.070312 9.90625 9.667969 10.503906 9.070312 L 10.902344 9.46875 C 10.304688 10.167969 9.40625 10.667969 8.3125 10.667969 C 6.417969 10.667969 4.824219 9.171875 4.824219 7.175781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.011719 2.992188 L 8.609375 2.992188 L 8.609375 22.03125 L 8.011719 22.03125 Z M 8.011719 2.992188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.128906 21.832031 L 13.394531 21.832031 L 13.394531 22.429688 L 3.128906 22.429688 Z M 3.128906 21.832031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.027344 18.640625 L 8.113281 8.175781 L 8.609375 8.472656 L 3.625 18.839844 Z M 3.027344 18.640625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.113281 8.472656 L 8.609375 8.175781 L 13.59375 18.640625 L 13.097656 18.839844 Z M 8.113281 8.472656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 9.007812 24.023438 C 9.007812 24.324219 8.710938 24.625 8.410156 24.625 C 8.113281 24.625 7.8125 24.324219 7.8125 24.023438 C 7.8125 23.726562 8.113281 23.425781 8.410156 23.425781 C 8.710938 23.425781 9.007812 23.726562 9.007812 24.023438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 7.464844 2.863281 L 7.828125 2.386719 L 8.539062 2.933594 L 8.175781 3.410156 Z M 7.464844 2.863281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.210938 2.992188 L 8.910156 2.492188 L 9.207031 2.890625 L 8.511719 3.488281 Z M 8.210938 2.992188 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4e77f84b8dd9488eb858a8b978ff08a2.svg";
export { ForwardRef as ReactComponent };